<ng-container *ngIf="is_loading">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-container>

<div style="margin-top: 30px">
  <form [formGroup]="myForm" (ngSubmit)="onSubmit()" novalidate>

    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px">

      <div>
        <mat-card style="width: 300px; height: 100%">

          <mat-card-content fxLayout="column">

            <mat-card-title >
              <h2 class="h2-card-title">Change Password</h2>
              <mat-divider></mat-divider>
            </mat-card-title>

            <mat-form-field style="margin-top: 15px">
              <mat-label>Current Password:</mat-label>
              <input matInput [type]="hide ? 'password' : 'text'" placeholder="password"  formControlName="previous_password" autocomplete="current-password">
              <button type="button" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                <mat-icon class="add-button">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
              <mat-error>
                <strong>Requires at least 1 Uppercase, Lowercase, Number and Special Character and min lentgh of 8 </strong>
              </mat-error>
            </mat-form-field>

            <mat-form-field style="margin-top: 15px">
            <mat-label>New Password:</mat-label>
            <input matInput [type]="hide_new ? 'password' : 'text'" placeholder="password"  formControlName="proposed_password" autocomplete="new-password">
            <button type="button" mat-icon-button matSuffix (click)="hide_new = !hide_new" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide_new">
              <mat-icon class="add-button">{{hide_new ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            <mat-error>
              <strong>Requires at least 1 Uppercase, Lowercase, Number and Special Character and min lentgh of 8 </strong>
            </mat-error>
            </mat-form-field>
          </mat-card-content>

          <button mat-raised-button color="accent" [disabled]="!myForm.valid" type="submit">Submit</button>

          <br><br>
          <ng-container *ngIf="is_response">
            <h2>{{response}}</h2>
          </ng-container>

<!--          <mat-progress-bar *ngIf="is_loading" mode="indeterminate" style="margin-top: 10px"></mat-progress-bar>-->
        </mat-card>
      </div>
    </div>

  </form>


</div>

